import React from 'react'
import ReactWOW from 'react-wow'
import { Link } from 'gatsby'
import bannerImg2 from '../../assets/images/banner-img2.png'
import {useTranslation} from "gatsby-plugin-react-i18next";

const CEXa = () => {
    const {t} = useTranslation();

    return (
        <div className="seo-agency-banner">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-12">
                        <div className="banner-wrapper-content">
                            <span className="sub-title">{t('ExpérienceCandidat')}</span>
                            <ReactWOW delay='.1s' animation='fadeInLeft'>
                                <h1>{t('home.CEXah1')}</h1>
                            </ReactWOW>

                            <ReactWOW delay='.1s' animation='fadeInLeft'>
                                <p>{t('home.CEXap')}</p>
                            </ReactWOW>

                            <ReactWOW delay='.1s' animation='fadeInRight'>
                                <div className="btn-box">
                                    <Link to="/interactive-job-candidacy-and-employability" className="default-btn">
                                        <i className="flaticon-right"></i>
                                        {t('EnSavoirPlus')}
                                        <span></span>
                                    </Link>
                                </div>
                            </ReactWOW>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-12">
                        <ReactWOW delay='.1s' animation='fadeInUp'>
                            <div className="banner-wrapper-image">
                                <img src={bannerImg2} alt="banner" />
                            </div>
                        </ReactWOW>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CEXa